import UI from './utils/UI'
import './lib/pinit'

UI({
  component: '.js-pinterest'
}, ({ component }) => {
  showPintrestButton()
})

// snow custom pinterest button if user does not have extention
function showPintrestButton () {
  const imageDiv = document.querySelectorAll('.js-pinterest')

  imageDiv.forEach(function(elem) {
    elem.addEventListener('mouseenter', function() {
      const pinterestButton = document.querySelector('a[class*="_button_pin"][class*="_save"]')
      const pin = document.querySelector('body span[style*="8675309"][style*="data:image/svg+xml"]')

      if (pin) {
        pinterestButton.style.display = 'none'
      } else {
        pinterestButton.style.display = 'block'
      }
    })

    elem.addEventListener('mouseout', function(event) {
      var e = event.toElement || event.relatedTarget
      if (e.parentNode === this || e === this) {
      } else {
        const pinterestButton = document.querySelector('a[class*="_button_pin"][class*="_save"]')
        pinterestButton.style.display = 'none'
      }
    })
  })
}
